// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"link-box-component_uk-open__BboAh","grecaptcha-badge":"link-box-component_grecaptcha-badge__pGkdy","linkBox":"link-box-component_linkBox__4qczR","imageWrapper":"link-box-component_imageWrapper__uR6hL","content":"link-box-component_content__dNDqH","linkList":"link-box-component_linkList__S6Sy4","icon":"link-box-component_icon__yE4xZ"};
    if(module.hot) {
      // 1754915947272
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  